// extracted by mini-css-extract-plugin
export default {"layout":"layout____N8tV","content":"content___KFsbd","title":"title___sV6Kp","subtitle":"subtitle___adF0T","body":"body___mW7Mi","pic":"pic___aDkN8","info":"info___or4Tk"};